import { Redirect } from 'react-router-dom';
import { PATH } from 'routes/constant';

const RedirectToMyConnectedAccounts = () => {
    return <Redirect to={PATH.CONNECTED_ACCOUNTS} />;
};

export default RedirectToMyConnectedAccounts;
